import{gql as e}from"@apollo/client";import{USER_FRAGMENT as o}from"./user.fragment.js";const r=e`
  fragment loginFragment on LoginGraphType {
    accessToken: token(shouldRemovePrefix: true)
    loginToken
    refreshToken(shouldRemovePrefix: true)
    user {
      ...userFragment
    }
  }

  ${o}
`;export{r as LOGIN_FRAGMENT};
//# sourceMappingURL=login.fragment.js.map
